<div class="container">
  <app-alert [show]="showMessage"
    [autohide]="99999999"
    [type]="alertMessage?.type"
    [message]="alertMessage?.text"
    [textFullWidth]="true"
    [hideCloseButton]="true"
  ></app-alert>
  <div class="pioneer-rx" *ngIf="progress !== PharmacyManagementSystemIntegrationStepsEnum.Finish">
    <div class="text-sm leading-5 font-medium mb-4">To complete your integration with PioneerRx, please sign the consent form. </div>
      <div class="relative flex flex-col items-center">
        <div class="anchor" (click)="scrollDown()" [class.hidden]="isSignaturePadVisible()"> 
          <img src="/assets/icons/icon-arrow-down2.svg">
          <span class="text-xs leading-4 font-medium;">Jump to signature</span>
        </div>
        <div class="doc" #doc>
            <app-pdf-viewer 
                #pdfViewer
                *ngIf="pdfUrl"
                [pdfSrc]="pdfUrl"
                [zoom]="zoom"
                [minZoom]="zoom"
            ></app-pdf-viewer>

            <app-signature-pad
              #signature 
              (drawEnd)="drawComplete($event)"
              (cleared)="signatureCleared()"
            ></app-signature-pad>
        </div>
    </div>
  </div>

  <div *ngIf="progress !== PharmacyManagementSystemIntegrationStepsEnum.Finish" class="controls">
    <app-button customClasses="w-full"
                text="Sign and Finish"
                class="next"
                [disabled]="(loading$ | async) || !isFormSigned"
                (clicked)="showPin()"
                [loading]="loading$ | async" 
    >
    </app-button>
    <app-button customClasses="w-full"
                subStyle="transparent"
                class="back"
                (clicked)="back.emit(PharmacyManagementSystemIntegrationStepsEnum.SelectType)"
                [disabled]="loading$ | async"
    >
      <img class="chevron-icon" src="assets/icons/icon-chevron-down-gray.svg" alt="chevron-left-icon" />
      Back
    </app-button>
  </div>

  <div *ngIf="progress === PharmacyManagementSystemIntegrationStepsEnum.Finish" 
    class="finish">
    <div class="pt-4 pb-4 font-normal text-sm"> 
      Please allow 48 hours for the integration to be completed. We'll notify you via email when it's ready to be enabled.
    </div>
    <app-button customClasses="w-full"
      text="Ok"
      (clicked)="OK()"
    > 
    </app-button>
  </div>

</div>